export default {
  allProjectReviewList: [],
  showTradePassportRedirect: null,
};
